module.exports = __webpack_public_path__ + "static/img/aepic-3.cc4e7e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-3.jpg
// module id = UIOZ
// module chunks = 51